var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBannerRow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.63125,
    width: 16.757,
    height: 9.46966,
    rx: 0.65,
    stroke: "#FFB600",
    strokeWidth: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 17.457,
    width: 16.957,
    height: 1.01359,
    rx: 0.25,
    fill: "#F3F3F3",
    stroke: "#B5B5B5",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.63125,
    width: 9.85784,
    height: 9.46966,
    rx: 0.65,
    fill: "#FFB600",
    fillOpacity: 0.5,
    stroke: "#FFB600",
    strokeWidth: 0.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 11.5531,
    width: 4.76886,
    height: 4.55234,
    rx: 0.65,
    fill: "#F3F3F3",
    stroke: "#C4C4C4",
    strokeWidth: 0.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.34414,
    y: 11.5531,
    width: 4.76886,
    height: 4.55234,
    rx: 0.65,
    fill: "#F3F3F3",
    stroke: "#C4C4C4",
    strokeWidth: 0.7
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3382,
    y: 11.5531,
    width: 4.76886,
    height: 4.55234,
    rx: 0.65,
    fill: "#F3F3F3",
    stroke: "#C4C4C4",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBannerRow);
export default __webpack_public_path__ + "static/media/ic-banner-row.6c627a9f5ad5eef8c467dfc9be4b6304.svg";
export { ForwardRef as ReactComponent };